import cx from "classnames";
import { useParallaxCaption } from "../../hooks/useParallaxCaption";
import bg from "./innovation-background.jpeg";
import "./Innovation.css";

const InnovationSection = () => {
  const show = useParallaxCaption(0.9);

  return (
    <section
      id="section-innovation"
      className="section-innovation flex flex-col justify-center"
    >
      <div className="background">
        <img src={bg} alt="innovation-background" />
      </div>
      <div className="container mx-auto flex flex-row justify-center md:justify-end mb-15 md:p-0">
        <div
          className={cx(
            "flex",
            "flex-col",
            "items-center",
            "fade",
            show && "show"
          )}
        >
          <div className="flex-1 my-12 text-box">
            <h1 className="nowrap font-regular sm:whitespace-nowrap">
              นวัตกรรมใหม่ล่าสุด
            </h1>
            <h2 className="text-2 nowrap sm:whitespace-nowrap">
              ของ Mitsubishi Electric
            </h2>
            <h2 className="text-3 large nowrap font-light">
              ที่ให้มากกว่าเรื่องดีไซน์
            </h2>
          </div>
          <p className="subtitle mx-auto" style={{ maxWidth: 380 }}>
            ด้วยหน้ากากแบบใหม่ สิทธิบัตรเฉพาะตัว <br />
            ที่
            <span className="whitespace-nowrap">ผสมผสาน</span>
            ความลงตัวระหว่างดีไซน์ที่สวยงาม และประสิทธิภาพในการใช้งาน
            ตอบโจทย์ทุกไลฟ์สไตล์
          </p>
        </div>
      </div>
    </section>
  );
};

export default InnovationSection;
